import { combineReducers } from 'redux';
import common from './reducers/common';
import home from './reducers/home';
import language from './reducers/language';
import { routerReducer } from 'react-router-redux';

export default combineReducers({  
  common,
  home,  
  router: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducer.js